import { FilterButton } from "components/components/Button/FilterButton";
import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const StyledFilterButton = styled(FilterButton)`
  margin: 8px 0 16px 0;
  padding: 0 0 2px 0;

  &:hover {
    margin-bottom: 16px;
  }

  &.active {
    margin-bottom: 16px;
  }
`;

export const AppliedFiltersContainer = styled.div`
  display: flex;
  align-content: center;
  margin-bottom: 8px;
`;

export const AppliedFilterTagsList = styled.div`
  display: flex;
  gap: 10px;
  flex-grow: 1;
  flex-wrap: wrap;

  & p {
    font-weight: ${fonts.semibold};
  }
`;

export const AppliedFilterTag = styled.div`
  border: 1px solid ${colours.elexonBlue};
  border-radius: 23px;
  color: ${colours.elexonBlue};
  padding: 0 10px;
  line-height: 1.7em;
`;

export const FiltersModalSection = styled.div`
  margin-bottom: 1em;
`;
